import styles from './UnauthorizedPage.module.scss';

/**
 * 403 page shown when the user lacks the required permission for a route.
 */
export function UnauthorizedPage() {
  const handleGoHome = () => {
    window.location.href = '/promote';
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.code}>403</h1>
        <h2 className={styles.title}>Access denied</h2>
        <p className={styles.description}>
          You do not have permission to view this page. Contact your organization administrator if
          you believe this is an error.
        </p>
        <button className={styles.button} onClick={handleGoHome} type="button">
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
